import React from "react";
import {DropdownButton, FormCheck, FormControl, InputGroup} from "react-bootstrap";
import DropdownItem from "react-bootstrap/DropdownItem";

export class SuperbillOtherInput extends React.Component {
    constructor(props) {
        super(props);
    }

    valueChanged = (e) => {
        let val = e.target.value;
        this.props.onValueChanged(val);
    }

    toggled = (e) => {
        this.props.onValueChanged(e.target.checked ? "" : null);
        if (e.target.checked) {
            this.textInput.focus();
        }
    }

    render() {
        return <InputGroup>
            <FormCheck label={this.props.label || "Other"} checked={this.props.value != null} onChange={this.toggled} inline/>
            <FormControl ref={(input) => { this.textInput = input; }} value={this.props.value || ""} onChange={this.valueChanged} size={"sm"} maxLength={255}/>
        </InputGroup>
    }
}